import React from "react";
import { ProductInterface } from "../../interfaces/product/product.interface";
import { BreadCrumbs } from "./BreadCrumbs";
import { Sku } from "./Sku";
import { useProductDispatch } from "../../stores/product/product.store";
import { gtag } from "../../stores/product/product.reducer";

interface HeaderProps {
    product: ProductInterface;
}

export const Header: React.FC<HeaderProps> = ({ product }) => {
    const dispatch = useProductDispatch();
    const copy = () => {
        dispatch(gtag('mn_item_id_copy'));
    }

    return (
        <>
            <BreadCrumbs breadCrumbs={ product.breadcrumbs } />
            <h1 onCopy={ () => copy() } className="text-[32px] font-semibold mt-4 hidden md:block">{ product.name }</h1>
            <Sku product={ product } className="hidden md:flex" />
        </>
    )
}